import React, { useEffect, useState } from "react";
import Select from "react-select";
import axios from "axios";
import moment from "moment";
import Loading from "./Components/LoadingScreen";
import { useLocation } from "react-router-dom";
import { useDispatch, useSelector } from "react-redux";
import { selectUser } from "./Components/features/userSlice";
import AllPagesMasterNavbar from "../src/Components/MasterNavbar/AllPagesMasterNavbar";
import { BsFileEarmarkPdf } from "react-icons/bs";
import { RiFileExcel2Line } from "react-icons/ri";
import ExcelJS from "exceljs";
import jsPDF from "jspdf";
import "jspdf-autotable";

const MainDashboardSummary = () => {
  const location = useLocation();
  const user = useSelector(selectUser);
  const userEmail = user.email;
  const menu = location.state ? location.state.menu : null;
  const BASEURL_GLOBAL = process.env.REACT_APP_BASEURL_GLOBAL;
  const authToken = window.sessionStorage.getItem("auth-token");
  const sclientSecret = window.sessionStorage.getItem("session-token");
  const currentDate = new Date();
  const startOfYear = new Date(currentDate.getFullYear(), 0, 1);
  const localStartOfYear = new Date(
    startOfYear.getTime() - startOfYear.getTimezoneOffset() * 60000
  );

  const [startdate, setStartdate] = useState(localStartOfYear.toISOString());
  const [enddate, setEnddate] = useState(currentDate.toISOString());
  const [listOfModules, setListOfModules] = useState([]);
  const [selModule, setSelModule] = useState("");
  const [isloading, setisloading] = useState(true);
  const [mainTableData, setMainTableData] = useState([]);
  const [detailsTableData, setDetailsTableData] = useState([]);
  const [mainTableLoading, setMainTableLoading] = useState(false);
  const [detailsTableLoading, setDetailsTableLoading] = useState(false);

  useEffect(() => {
    FetchDetails();
  }, []);

  function FetchDetails() {
    axios
      .get(`${BASEURL_GLOBAL}/globalViewHandler?viewname=739`, {
        headers: {
          "auth-token": authToken,
          "session-token": sclientSecret,
        },
      })
      .then((res) => {
        setListOfModules(res.data);
        setisloading(false);
      })
      .catch((err) => {
        console.error(
          "Error while fetching /globalViewHandler?viewname=739",
          err
        );
        setisloading(false);
      });
  }

  function isValidDate(dateString) {
    const dateRegex = /^\d{2}\/\d{2}\/\d{4}$/; // Matches DD/MM/YYYY format

    if (!dateRegex.test(dateString)) {
      return false; // Format is invalid
    }

    const [day, month, year] = dateString.split("/").map(Number);

    // Year must be greater than 1900
    if (year < 1900) {
      return false;
    }

    // Month must be between 1 and 12
    if (month < 1 || month > 12) {
      return false;
    }

    // Validate day for the given month and year
    const daysInMonth = new Date(year, month, 0).getDate();
    if (day < 1 || day > daysInMonth) {
      return false;
    }

    return true;
  }

  function fetchCounterDetails(moduleName) {
    setMainTableLoading(true);
    axios
      .get(`${BASEURL_GLOBAL}/globalViewHandler?viewname=740`, {
        headers: {
          "auth-token": authToken,
          "session-token": sclientSecret,
        },
      })
      .then((res) => {
        const viewData = res?.data?.filter(
          (view) => view.MODULE === moduleName
        );
        // Creating an array of API calls
        const requests = viewData
          .map((view) => {
            if (view?.VIEWNAME) {
              if (isValidDate(startdate) && isValidDate(enddate)) {
                return axios
                  .get(
                    `${BASEURL_GLOBAL}/globalViewHandlerFunction?viewname=${
                      view?.VIEWNAME
                    }&startdate=${moment(startdate).format(
                      "YYYY-MM-DD"
                    )}&enddate=${moment(enddate).format("YYYY-MM-DD")}`,
                    {
                      headers: {
                        "auth-token": authToken,
                        "session-token": sclientSecret,
                      },
                    }
                  )
                  .then((response) => ({
                    viewName: view?.VIEWNAME,
                    counterData: response.data[0] || null, // Ensure we get a valid response
                  }))
                  .catch((err) => {
                    console.error(
                      `Error fetching data for ${view?.VIEWNAME}`,
                      err
                    );
                    return { viewName: view?.VIEWNAME, counterData: null }; // Return null for failed requests
                  });
              }
            }
            return null;
          })
          .filter(Boolean); // Remove null values

        // Process all requests
        Promise.all(requests)
          .then((responses) => {
            const updatedTableData = viewData?.map((view) => {
              const counterEntry = responses?.find(
                (r) => r?.viewName === view?.VIEWNAME
              );

              let counterValue = null;
              if (counterEntry?.counterData) {
                const counterObj = counterEntry?.counterData;
                const counterKeys = Object?.keys(counterObj);
                if (counterKeys?.length > 0) {
                  counterValue = counterObj[counterKeys[0]]; // Extract first value
                }
              }

              return {
                ITEMNAME: view?.ITEMNAME,
                VIEWNAME: view?.VIEWNAME,
                DRILLDOWNVIEWNAME: view?.DRILLDOWNVIEWNAME,
                COUNTER: counterValue, // Assigning extracted counter value
              };
            });

            console.log(updatedTableData);

            setMainTableData(updatedTableData);
            setMainTableLoading(false);
          })
          .catch((err) => {
            console.error("Error while fetching view details", err);
            setMainTableLoading(false);
          });
      })
      .catch((err) => {
        console.error(
          "Error while fetching /globalViewHandler?viewname=740",
          err
        );
        setMainTableLoading(false);
      });
  }

  function FetchDetailsTable(objectName) {
    setDetailsTableLoading(true);
    axios
      .get(
        `${BASEURL_GLOBAL}/globalViewHandlerFunction?viewname=${objectName}&startdate=${moment(
          startdate
        ).format("YYYY-MM-DD")}&enddate=${moment(enddate).format(
          "YYYY-MM-DD"
        )}`,
        {
          headers: {
            "auth-token": authToken,
            "session-token": sclientSecret,
          },
        }
      )
      .then((res) => {
        setDetailsTableData(res?.data);
        setDetailsTableLoading(false);
      })
      .catch((err) => {
        console.error(
          `Error while fetching /globalViewHandler?viewname=${objectName}`,
          err
        );
        setDetailsTableLoading(false);
      });
  }

  // Excel and PDF Download
  const exportTableToExcel = (tableId) => {
    const table = document.getElementById(tableId);
    const workbook = new ExcelJS.Workbook();
    const worksheet = workbook.addWorksheet("Sheet 1");
    const rows = table.querySelectorAll("tbody tr");
    const headers = Array.from(table.querySelectorAll("thead td")).map((td) =>
      td.textContent.trim()
    );

    // Set column headers dynamically
    if (headers.length > 0) {
      const headerRow = worksheet.addRow(headers);
      headerRow.eachCell((cell) => {
        cell.font = { bold: true };
      });
    }

    // Add rows dynamically
    rows.forEach((row) => {
      const rowData = Array.from(row.querySelectorAll("td")).map((cell) =>
        cell.textContent.trim()
      );
      worksheet.addRow(rowData);
    });

    // Auto adjust column widths
    worksheet.columns.forEach((column) => {
      let maxLength = 0;
      column.eachCell({ includeEmpty: true }, (cell) => {
        const cellValue = cell.value ? cell.value.toString() : "";
        maxLength = Math.max(maxLength, cellValue.length);
      });
      column.width = maxLength + 2;
    });

    // Create and download the Excel file
    workbook.xlsx.writeBuffer().then((buffer) => {
      const blob = new Blob([buffer], {
        type: "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet",
      });
      const url = window.URL.createObjectURL(blob);
      const link = document.createElement("a");
      link.href = url;
      link.download =
        tableId === "mainTable"
          ? "KPI_Dashbaords_Main_Data.xlsx"
          : "KPI_Dashbaords_Detailed_Data.xlsx";
      document.body.appendChild(link);
      link.click();
      document.body.removeChild(link);
    });
  };

  const exportTableToPDF = (tableId) => {
    const table = document.getElementById(tableId);
    const doc = new jsPDF();
    doc.text(
      tableId === "mainTable"
        ? "KPI Dashboards Main Data"
        : "KPI Dashboards Detailed Data",
      10,
      10
    );

    const headers = Array.from(table.querySelectorAll("thead td")).map((td) =>
      td.textContent.trim()
    );

    const rows = Array.from(table.querySelectorAll("tbody tr")).map((row) =>
      Array.from(row.querySelectorAll("td")).map((cell) =>
        cell.textContent.trim()
      )
    );

    doc.autoTable({
      head: [headers],
      body: rows,
      startY: 20,
      showHead: "firstPage",
    });

    doc.save(
      tableId === "mainTable"
        ? "KPI_Dashboards_Main_Data.pdf"
        : "KPI_Dashboards_Detailed_Data.pdf"
    );
  };

  if (isloading) {
    return <Loading />;
  }

  return (
    <div className="bg-gray-50 min-h-[100vh]">
      <AllPagesMasterNavbar />
      <header className="header__of__main lg:flex justify-between items-end px-5">
        <h1 className="header__of__page text-blue-950 text-center underline">
          {menu ? menu : ""}
        </h1>
      </header>
      <section className="lg:flex items-center gap-5 mx-5">
        <div className="lg:flex w-full items-center gap-3">
          <p>Module :</p>
          <Select
            className="w-64 z-[1000]"
            value={
              selModule
                ? { value: selModule, label: selModule }
                : { value: "", label: "Select Module" }
            }
            onChange={(e) => {
              if (e.value !== "") {
                setSelModule(e.value);
                setMainTableData([]);
                setDetailsTableData([]);
                fetchCounterDetails(e.value);
              } else {
                setSelModule(e.value);
                setMainTableData([]);
                setDetailsTableData([]);
              }
            }}
            options={[
              { value: "", label: "Select Module" },
              ...listOfModules.map((data) => ({
                value: data.MODULESNAME,
                label: data.MODULESNAME,
              })),
            ]}
          />
          <label className=" text-gray-700">From Date</label>
          <input
            type="date"
            onChange={(e) => {
              if (e.target.value !== "") {
                setStartdate(e.target.value);
                setMainTableData([]);
                setDetailsTableData([]);
                fetchCounterDetails(selModule);
              } else {
                setStartdate(e.target.value);
                setMainTableData([]);
                setDetailsTableData([]);
              }
            }}
            value={startdate.split("T")[0]}
            placeholder="From Date"
          />
          <label className=" text-gray-700">End Date</label>
          <input
            type="date"
            onChange={(e) => {
              if (e.target.value !== "") {
                setEnddate(e.target.value);
                setMainTableData([]);
                setDetailsTableData([]);
                fetchCounterDetails(selModule);
              } else {
                setEnddate(e.target.value);
                setMainTableData([]);
                setDetailsTableData([]);
              }
            }}
            value={enddate.split("T")[0]}
            placeholder="To Date"
          />
        </div>
      </section>

      {/* Counter Table */}
      {mainTableLoading ? (
        <Loading />
      ) : (
        <>
          {mainTableData.length > 0 && (
            <div className="h-auto px-4">
              <div className="flex justify-end gap-2 cursor-pointer">
                <RiFileExcel2Line
                  onClick={() => exportTableToExcel("mainTable")}
                  size={35}
                />
                <BsFileEarmarkPdf
                  onClick={() => exportTableToPDF("mainTable")}
                  size={35}
                />
              </div>
              <table
                className="custom-table text-sm overflow__y__ relative w-full"
                id="mainTable"
              >
                <thead
                  className="header-cell sticky top-[0px] left-[10px]"
                  style={{ zIndex: 50 }}
                >
                  <tr>
                    <td className="">ITEM NAME </td>
                    <td className="text-right">AMOUNT</td>
                  </tr>
                </thead>
                <tbody>
                  {mainTableData?.map((item, index) => (
                    <tr
                      key={index}
                      style={{
                        textTransform: "uppercase",
                      }}
                      className="cursor-pointer"
                      onClick={() => {
                        setDetailsTableData([]);
                        FetchDetailsTable(item?.DRILLDOWNVIEWNAME);
                      }}
                    >
                      <td className="">
                        {item.ITEMNAME ? item.ITEMNAME : "NA"}
                      </td>{" "}
                      <td className="text-right">
                        {item.COUNTER
                          ? item.COUNTER?.toLocaleString(undefined, {
                              minimumFractionDigits: 2,
                              maximumFractionDigits: 2,
                            })
                          : "0"}
                      </td>
                    </tr>
                  ))}
                </tbody>
              </table>
            </div>
          )}
        </>
      )}
      {/* Details Table  */}

      {detailsTableLoading ? (
        <Loading />
      ) : (
        <>
          {detailsTableData.length > 0 && (
            <div className="overflow-y-auto h-auto px-4">
              <header className="header__of__main lg:flex justify-between items-end mt-5">
                <h1 className="header__of__page text-blue-950 text-center underline">
                  DETAILED DATA
                </h1>
                <div className="flex justify-end gap-2 cursor-pointer">
                  <RiFileExcel2Line
                    onClick={() => exportTableToExcel("detailedTable")}
                    size={35}
                  />
                  <BsFileEarmarkPdf
                    onClick={() => exportTableToPDF("detailedTable")}
                    size={35}
                  />
                </div>
              </header>
              <table
                className="custom-table text-sm overflow__y__ relative w-full"
                id="detailedTable"
              >
                {/* Dynamic Table Headers */}
                <thead
                  className="header-cell sticky top-[0px] left-[10px]"
                  style={{ zIndex: 50 }}
                >
                  <tr>
                    {detailsTableData.length > 0 &&
                      Object.keys(detailsTableData[0]).map((key, index) => (
                        <td key={index} className="uppercase">
                          {key.replace(/_/g, " ")}
                        </td>
                      ))}
                  </tr>
                </thead>

                {/* Dynamic Table Body */}
                <tbody>
                  {detailsTableData.map((item, rowIndex) => (
                    <tr key={rowIndex} style={{ textTransform: "uppercase" }}>
                      {Object.entries(item).map(([key, value], colIndex) => {
                        const isAmountField =
                          key === "AMOUNT" ||
                          key === "RATE" ||
                          key === "AMOUNT CLIENT CURRENCY" ||
                          key === "AMOUNT LOCAL CURRENCY" ||
                          key === "AMOUNTLOCALCURRENCY" ||
                          key === "PAID AMOUNT" ||
                          key === "CREDITNOTE AMOUNT" ||
                          key === "AMOUNT PENDING" ||
                          key === "AMOUNT INC VAT" ||
                          key === "PO AMOUNT";
                        // Apply formatting only for AMOUNT
                        const isNumeric = typeof value === "number";
                        const isDate =
                          typeof value === "string" &&
                          /^\d{4}-\d{2}-\d{2}T\d{2}:\d{2}:\d{2}.\d{3}Z$/.test(
                            value
                          ) &&
                          moment(value, moment.ISO_8601, true).isValid();
                        return (
                          <td
                            key={colIndex}
                            className={
                              isAmountField || isNumeric
                                ? "text-right"
                                : "text-left"
                            }
                            style={{ padding: "8px" }}
                          >
                            {isDate
                              ? moment(value).format("DD-MM-YYYY") // Format date as DD-MM-YYYY
                              : isAmountField
                              ? Number(value).toLocaleString("en-US", {
                                  minimumFractionDigits: 2,
                                  maximumFractionDigits: 2,
                                }) // Format AMOUNT with commas
                              : value || "0"}
                            {/* Keep other values as-is */}
                          </td>
                        );
                      })}
                    </tr>
                  ))}
                </tbody>
              </table>
            </div>
          )}
        </>
      )}
    </div>
  );
};

export default MainDashboardSummary;
